import React, { Component } from "react";

export class Link extends Component {
  getStyle = () => {
    return {
      marginRight: this.props.linkData._ !== "." ? "15px" : "inherit",
    };
  };

  render() {
    console.log(this.props.linkData);
    const { _, $ } = this.props.linkData;
    const { text, url } = $;
    return (
      <p className="linkData">
        <span style={this.getStyle()}>
          {_.substring(0, 2) === "#D" ? _.substring(2, 12) : ""}
        </span>
        <a
          href={_.includes("#L") ? _.substring(_.indexOf("#L") + 2) : url.replace("http://", "https://")}
          target="_blank"
          rel="noopener noreferrer"
        >
          {text}
        </a>
      </p>
    );
  }
}

export default Link;
